export const comments_5698794 = {"data":{"data":[],"links":{}}}